export const skipToContentAccessibility = (event: FocusEvent) => {
  let logoFocusIndex = 0;
  if (event.relatedTarget) {
    const logoElem: HTMLElement = document
      .querySelector('ds-contextual-navigation')
      .shadowRoot.querySelector('[title="SAP Logo"]');

    const parentElem = logoElem?.parentElement;
    parentElem.setAttribute('tabindex', '-1');

    const contentSkipElement = document.createElement('div');
    contentSkipElement.setAttribute('aria-label', 'Skip to content');
    contentSkipElement.style.margin = '5px';
    contentSkipElement.style.color = 'blue';
    contentSkipElement.style.fontSize = '16px';
    contentSkipElement.style.cursor = 'pointer';
    contentSkipElement.textContent = 'Skip to content';

    const groupSkipElem: HTMLElement = document.querySelector('[libGroupSkip]');

    if (isHeaderFocusedButClicked(event)) {
      logoElem.addEventListener('click', () => {
        const url = logoElem.getAttribute('href');
        window.location.replace(url);
      });
    } else if (isHeaderFocusedOutThenIn(event)) {
      //avatar icon
      (
        document.querySelector(
          'ds-contextual-navigation-profile'
        ) as HTMLElement
      ).focus();
    } else {
      parentElem.addEventListener('focus', () => {
        parentElem.replaceChild(contentSkipElement, logoElem);
        parentElem.addEventListener('blur', () => {
          parentElem.replaceChild(logoElem, contentSkipElement);
          if (logoFocusIndex !== 0) {
            logoElem.focus();
          }
          logoFocusIndex++;
        });
        parentElem.addEventListener('click', () => {
          groupSkipElem.focus();
        });
        parentElem.addEventListener('keypress', (event) => {
          if (event.key === 'Enter') {
            groupSkipElem.focus();
          }
        });
      });

      parentElem.focus();
    }
  }
};

function isHeaderFocusedButClicked(event: FocusEvent): boolean {
  return (event.relatedTarget as HTMLElement)?.offsetParent?.classList.contains(
    'contextual-navigation-wrapper'
  );
}

function isHeaderFocusedOutThenIn(event: FocusEvent): boolean {
  return (event.relatedTarget as HTMLElement)?.localName === 'udex-link';
}
